import { StatusMeta } from './types';
import { Radio } from '@silverfort/sf-components';

export interface StatusOptionProps {
    statusMeta: StatusMeta;
    isSelected: boolean;
    onSelection: (statusMeta: StatusMeta) => void;
    title: string;
    description: string;
}

const StatusOption = ({ statusMeta, isSelected, onSelection, title, description }: StatusOptionProps) => {
    const handleClick = () => {
        if (!isSelected) onSelection(statusMeta);
    };

    return (
        <div
            className="flex flex-col gap-1 p-4 w-full rounded-lg border cursor-pointer hover:border-sf-gray-800"
            onClick={(e) => {
                handleClick();
                e.stopPropagation();
            }}>
            <Radio
                onChange={(e) => {
                    handleClick();
                    e.stopPropagation();
                }}
                checked={isSelected}
                title={title}
                value=""
                containerClassName="font-medium text-13"
            />
            <div className="whitespace-pre-line font-sf text-12 text-sf-gray-800">{description}</div>
        </div>
    );
};

export default StatusOption;
